import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const KompletteraUppgifter = lazy(() => import("@/pages/KompletteraUppgifter"));

export const Route = createFileRoute("/komplettera-uppgifter")({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    t: typeof search["t"] === "string" ? search["t"] : "",
  }),
  head: () => ({
    meta: [
      { title: "Komplettera din beställning | Elmarknad.se" },
      {
        name: "description",
        content:
          "Komplettera uppgifterna i din bytesförfrågan så skickar vi beställningen till elhandlaren på nytt.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      { property: "og:title", content: "Komplettera din beställning | Elmarknad.se" },
      {
        property: "og:description",
        content: "Komplettera uppgifterna i din bytesförfrågan hos Elmarknad.se.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <KompletteraUppgifter />,
});
